import { useQuery } from "react-query";

import { zodParseWithLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { OpenFoodFactsSearchResult, OpenFoodFactsSearchResultSchema } from "./types";

export const openFoodFactsSearchKey = "openFoodFactsSearch" as const;

type UseOpenFoodFactsSearchOptions = {
    query: string;
    page: number;
    pageSize?: number;
    enabled?: boolean;
};

export const useOpenFoodFactsSearch = (options: UseOpenFoodFactsSearchOptions) => {
    const { query, page, pageSize = 12, enabled = true } = options;
    const normalizedQuery = query.trim();
    const hasSearchCriteria = normalizedQuery.length >= 2;

    return useQuery<OpenFoodFactsSearchResult>({
        queryKey: [openFoodFactsSearchKey, normalizedQuery, page, pageSize],
        enabled: enabled && hasSearchCriteria,
        keepPreviousData: true,
        queryFn: async () => {
            const response = await loggedInApiCall.get("/api/open-food-facts/search", {
                params: {
                    q: normalizedQuery,
                    page,
                    pageSize,
                },
            });

            return zodParseWithLog(response.data, OpenFoodFactsSearchResultSchema, openFoodFactsSearchKey);
        },
    });
};
